<template>
  <section class="video-text-form">
    <div class="wrapper">
      <h2 v-if="title" class="video-text-form__title text-subheader">{{ title }}</h2>
      <div class="video-text-form__container">
        <div class="video-text-form__left">
          <video
            v-if="previewVideo"
            :controls="false"
            playsinline
            loop
            muted
            autoplay
            :poster="`${url}${image.source}`"
            class="video-text-form__video"
          >
            <source :src="`${url}${previewVideo}`" type="video/mp4" />
            Ваш браузер не поддерживает видео.
          </video>
          <div v-else class="reels__slider-slide video" @click="openMediaModal(0)">
            <UIPictureTag
              :image-seo="imageSeo"
              :image-webp="`${url}${image.webp}`"
              :image-original="`${url}${image.source}`"
            />
            <div class="reels__slider-wrapper"></div>

            <UIButton>
              <NuxtIcon name="IconPlay" />
            </UIButton>
          </div>
          <div
            v-if="video_title"
            class="video-text-form__subtitle"
            v-html="sanitizeHtml(video_title)"
          ></div>
        </div>
        <div class="video-text-form__right">
          <div v-if="text" class="video-text-form__desc" v-html="sanitizeHtml(text)"></div>
          <UIButton type="button" size="l" @click="openFeedback">
            Записаться на приём
          </UIButton>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { ImageItem, ImageSEO, FormModel } from '~/types/pages';
import { useRuntimeConfig, useMediaModal, onUnmounted, computed } from '#imports';
import { sanitizeHtml } from '~/composables/sanitizeHtml';
import UIButton from '~/components/UI/button/UIButton.vue';
import { useFeedbackWidget } from '~/composables/useFeedbackWidget';
import './styles.scss';
interface Props {
  title: string;
  image: ImageItem;
  imageSeo: ImageSEO;
  video_title: string;
  previewVideo: string;
  link: string;
  text: string;
  formTitle: string;
  formModel: FormModel;
}

const url = useRuntimeConfig().public.siteUrl;

const props = defineProps<Props>();

const { open: openFeedback } = useFeedbackWidget();


const dataSource = computed(() => ({
  html: `<div class="reelse__frame">
            <iframe
              src="${props.link}"
              allow="autoplay; encrypted-media; fullscreen; picture-in-picture;" frameborder="0" allowfullscreen>
            </iframe>
         </div>`,
}));

const { destroyMediaModal, openMediaModal } = useMediaModal([dataSource.value]);

onUnmounted(() => destroyMediaModal());
</script>
